
    import '/mnt/src/components/Tooltip/index.md?watch=parent';
    export const demoIndex = {
  ids: ["tooltip-demo-comprehensivedemo"],
  getter: () => import(/* webpackChunkName: "meta__components" */'/mnt/src/components/Tooltip/index.md?type=demo')
};